import { useMemo, useState } from 'react';
import {
  isRangeValid,
  resolveWorkspaceDatePreset,
  type DateRange,
} from '@/api/reportDateRanges';
import type { WorkspaceDatePresetId } from '@/constants/Constant_Preset_Variables';

export type RecommendationRangePreset = WorkspaceDatePresetId | 'custom';

export function useRecommendationDateRange() {
  const defaultRange = useMemo(() => resolveWorkspaceDatePreset('lastMonth').current, []);
  const [preset, setPreset] = useState<RecommendationRangePreset>('lastMonth');
  const [customRange, setCustomRange] = useState<DateRange>(defaultRange);

  const range = useMemo(() => {
    if (preset === 'custom') return customRange;
    return resolveWorkspaceDatePreset(preset).current;
  }, [preset, customRange.startDate, customRange.endDate]);

  const invalidRange = !isRangeValid(range);

  return {
    preset,
    setPreset,
    customRange,
    setCustomRange,
    range,
    invalidRange,
  };
}
